import { z } from "zod";
export const WhatsappTemplatesSchema = z.object({
    pedidoNuevo: z.string(),
    pedidoEnPreparacion: z.string(),
    pedidoListoRecoger: z.string(),
    pedidoEnCamino: z.string(),
    pedidoEntregado: z.string(),
    botRespuestaAuto: z.string(),
});
export const WhatsappStatusSchema = z.object({
    status: z.enum(["DISCONNECTED", "CONNECTING", "CONNECTED", "QR_READY"]),
    qrCodeDataUrl: z.string().nullable(),
    connectedPhone: z.string().nullable(),
    connectedName: z.string().nullable(),
    botActive: z.boolean(),
    templates: WhatsappTemplatesSchema,
});
export const UpdateWhatsappSettingsSchema = z.object({
    botActive: z.boolean().optional(),
    templates: WhatsappTemplatesSchema.partial().optional(),
});
export const SendTestMessageSchema = z.object({
    telefono: z.string().min(7, "Teléfono inválido"),
    mensaje: z.string().min(1, "El mensaje no puede estar vacío"),
});
//# sourceMappingURL=whatsapp.schema.js.map